import React, { useEffect, useState } from "react";
import Grid from "../../Components/Grid";
import { Button, Notification, Pagination, toaster } from "rsuite";
import format_number from "../../Helpers/number_formatter";
import { ERP_APi } from "../../Api";
import Translation from "../../translation/translation";
import Swal from "sweetalert2";

const DeliveryBandUnDeclared = () => {
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [filterModel, setFilterModel] = useState({
    pageIndex: 1,
    pageSize: 20,
    sortDirection: "DESC",
    sortField: "created",
  });

  const fetch = () => {
    ERP_APi.createERPApiEndpoint(
      "wind-billing/" +
        ERP_APi.ENDPOINTS_ERP.unDeclaredDeliveryForm +
        "/perPage",
      {
        ...filterModel,
      }
    )
      .fetchAll()
      .then((res) => {
        setData(res.data.content);
        setTotalCount(res.data.totalElements);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    fetch();
  }, [filterModel]);

  const handlePaymentSelection = (id) => {
    setSelectedPayment((prev) => (prev === id ? null : id));
  };

  const columns = [
    {
      value: "id",
      type: "checkbox",
      render: (v) => (
        <input
          type="checkbox"
          checked={selectedPayment === v}
          onChange={() => {
            handlePaymentSelection(v);
          }}
        />
      ),
    },
    {
      value: "invoiceNumber",
      name: "Réference",
      render: (v) => <a>{v}</a>,
    },
    {
      value: "deliveryDate",
      name: "Date",
      render: (v) => <a>{v}</a>,
    },
    {
      value: "invoicetype",
      name: "Type",
      render: (v) => <a> {v}</a>,
    },
    {
      value: "lineModels",
      name: "Service",
      render: (v) => <a>{v ? v[0].descriptionproduct?.toUpperCase() : "-"}</a>,
    },
    {
      value: "totalTtc",
      name: "Montant",
      render: (v) => <a>{v ? format_number(v) : "-"}</a>,
    },
    {
      value: "devise",
      name: "Devise",
      render: (v) => <a>{v}</a>,
    },
  ];

  const transformer = () => {
    ERP_APi.createERPApiEndpoint(
      "wind-billing/" +
        ERP_APi.ENDPOINTS_ERP.declaredDeliveryForm +
        `/transformToD`,
      {
        id: selectedPayment,
      }
    )
      .create2()
      .then((res) => {
        fetch();
        setSelectedPayment(null);
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Element a été bien ajouté !",
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((error) => {
        console.log(error, "error");
        toaster.push(
          <Notification type="error" header={Translation.errorHeader} closable>
            {error?.response?.data?.title ||
              error?.response?.data?.message ||
              Translation.error}
          </Notification>,
          { placement: "topEnd" }
        );
      });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
          padding: "5px",
        }}
      >
        {selectedPayment && (
          <div style={{ marginLeft: "auto", textAlign: "right" }}>
            <Button
              onClick={transformer}
              style={{ margin: 5 }}
              appearance="primary"
            >
              Transformer
            </Button>
          </div>
        )}
      </div>
      <Grid noAdvancedActions columns={columns} rows={data} />
      <div style={{ padding: 20, background: "#fff" }}>
        <Pagination
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="md"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={totalCount}
          limitOptions={[10, 20, 50, 100]}
          limit={filterModel.pageSize}
          activePage={filterModel.pageIndex}
          onChangePage={(pageIndex) => {
            window.scrollTo(0, 0);
            setFilterModel((prev) => {
              return { ...prev, pageIndex };
            });
          }}
          onChangeLimit={(pageSize) => {
            setFilterModel((prev) => {
              return { ...prev, pageSize, page: 1 };
            });
          }}
        />
      </div>
    </div>
  );
};

export default DeliveryBandUnDeclared;
